var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { createUIElement } from "../helpers";
import { UserIcon } from "../icons";
var AVATAR_SIZE = '32px';
var DEFAULT_AVATAR_SRC = React.createElement(UserIcon, null);
var CSS = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-block;\n    height: ", ";\n    width: ", ";\n    vertical-align: top;\n"], ["\n    display: inline-block;\n    height: ", ";\n    width: ", ";\n    vertical-align: top;\n"])), AVATAR_SIZE, AVATAR_SIZE);
var WrapperSVG = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    overflow: hidden;\n\n    ", "\n\n    svg {\n        display: block;\n        width: 100%;\n        height: 100%;\n    }\n"], ["\n    overflow: hidden;\n\n    ", "\n\n    svg {\n        display: block;\n        width: 100%;\n        height: 100%;\n    }\n"])), CSS);
var Icon = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    background-image: ", ";\n    background-repeat: no-repeat;\n    background-position: 0 0;\n    background-size: contain;\n\n    ", "\n"], ["\n    background-image: ", ";\n    background-repeat: no-repeat;\n    background-position: 0 0;\n    background-size: contain;\n\n    ", "\n"])), function (_a) {
    var src = _a.src;
    return "url(" + src + ")";
}, CSS);
var StyledAvatar = styled(React.forwardRef(function (_a, ref) {
    var src = _a.src, rest = __rest(_a, ["src"]);
    if (React.isValidElement(src)) {
        return (React.createElement(WrapperSVG, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'svg-avatar', ref: ref }), src));
    }
    return (React.createElement(Icon, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'avatar', src: src, ref: ref })));
}))(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    background-color: ", ";\n    ", "\n"], ["\n    background-color: ", ";\n    ",
    "\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
}, function (_a) {
    var _b = _a.rounded, rounded = _b === void 0 ? true : _b, src = _a.src;
    return rounded && src !== DEFAULT_AVATAR_SRC ? "border-radius: 50%;" : '';
});
export var Avatar = createUIElement('Avatar', function (_a, ref) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.rounded, rounded = _c === void 0 ? true : _c, _d = _a.src, src = _d === void 0 ? DEFAULT_AVATAR_SRC : _d, backgroundColor = _a.backgroundColor, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "rounded", "src", "backgroundColor", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (React.createElement(StyledAvatar, __assign({}, rest, { "data-selector-id": rest['data-selector-id'], className: "vm-Avatar " + className, rounded: rounded, src: src, backgroundColor: backgroundColor, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style })));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Avatar.js.map